<template>
  <DataView
    :context="context"
    :defaultCheckedCols="checkedCols"
    :defaultCheckedMetrics="checkedMetrics"
    :plotMetrics="plotMetrics"
    :fixedColumns="fixedColumns"
    :initialTemplate="template"
    :defaultSort="defaultSort"
    :back="parseInt(back)"
  ></DataView>
</template>

<script>
import DataView from "@/components/DataView";
export default {
  name: "Engagement",
  components: { DataView },
  props : {
    template: {
      default: "Default",
      type:  String
    },
    back: {
      default: "0",
      type:  String
    }
  },
  data() {
    return {
      context: "engagement",
      defaultSort: "Total Visits",
      checkedCols: ["AdNetwork"],
      checkedMetrics: [
        "Total Visits",
        "Active Sessions",
        "Active Session Duration",
        "Active Session Rate",
        "Button Clicks",
        "Link Clicks",
        "Image Clicks",
        "Input Clicks",
        "Mouse Scrolled Visits",
        "Scrolled Visits Rate",
        "Scroll Depth 25%",
        "Scroll Depth 50%",
        "Scroll Depth 75%",
        "Scroll Depth 100%",
      ],
      plotMetrics: ["Total Visits", "Active Session Rate"],
      fixedColumns: false,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Engagement.vue